module.exports = __webpack_public_path__ + "img/首页2-1.053a1a85.svg";